import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=150b6ad0&scoped=true&"
import script from "./GoodsCard.vue?vue&type=script&lang=js&"
export * from "./GoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=150b6ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b6ad0",
  null
  
)

export default component.exports